import React from 'react';

import './ModalView.css';

function ModalView({ children }) {
  return <div className="modal-view">{children}</div>;
}

export default ModalView;
